<template>
	<div class="van-nav-bar-div">
		<van-nav-bar  :title="$route.meta.title" left-text="" left-arrow @click-left="onClickLeft" @click-right="onClickRight">
			<template #right>
				<van-icon name="wap-home-o" size="18" />
			</template>
		</van-nav-bar>
	</div>
</template>
<script>
	export default {
		props: ["active"],
		data() {
			return {

			}
		},
		mounted() {
			this.index = this.active || 0;
		},
		methods: {
			onClickLeft() {
				this.$router.go(-1)
			},
			onClickRight() {
				this.$router.push({path:'/'})
               // this.$router.replace({name:"/"})
			}
		}
	}
</script>
<style lang="less">
	// .van-tabbar-item__icon img {
	// 	width: 24px;
	// 	height: 24px !important;
	// }
    .van-nav-bar-div{
		position:fixed;
		width:47px;
		top:0;
		left:0;
		width:100%;
		background:#FFF;
		z-index:1000;
	}
	.van-nav-bar .van-icon {
		color: #333 !important;
	}

	::v-deep .van-nav-bar__text {
		color: #333;
	}

	::v-deep .van-ellipsis {
		color: #333;
	}
</style>
